export default __webpack_public_path__ + "static/media/MagnifyingGlass.863fa1e9.svg";